import { Branch } from '@/types/branch'
import { create } from 'zustand'
interface BranchStore {
  myBranches: Branch[]
  setMyBranches: (branches: Branch[]) => void
}

const initialValue = {
  myBranches: [],
}
const handleOrder = (branches: Branch[]) => {
  const branchesOrder = branches.filter((el) => !el.isMainBranch)
  const findMainbranch = branches.find((el) => el.isMainBranch)
  if (findMainbranch) {
    branchesOrder.unshift(findMainbranch)
  }
  return branchesOrder
}
export const useBranchStore = create<BranchStore>((set) => ({
  ...initialValue,
  setMyBranches: (val) => set(() => ({ myBranches: handleOrder(val) })),
}))
